import { Image, LI } from "../../../../AbstractElements";
import { GROUPING_FIRST } from "../../../../Data/UiKit/Avatars";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const GroupingFirst = () => {
  return (
    <div className="customers d-inline-block avatar-group">
      <ul className="simple-list">
        <LI className="d-inline-block">
          <Image className="img-100 b-r-8" src={dynamicImage("avtar/4.jpg")} alt="image" />
        </LI>
        {GROUPING_FIRST.map(({ className, src }, index) => (
          <LI className="d-inline-block" key={index}>
            <Image className={`${className} h-auto`} src={src} alt="image" />
          </LI>
        ))}
      </ul>
    </div>
  );
};
